import React from "react";
import * as styles from "./AddDebitCardStep.module.scss";
import {
  AddCardForm,
  type AddCardFormValues,
} from "../../add-card-form/AddCardForm";
import { walletService } from "features/wallet/services/wallet";
import { useDepositWizard } from "features/wallet/components/deposit/hooks/useDepositWizard";
import { toast, useWizard } from "@picklebet/ui";

export const AddDebitCardStep = () => {
  const { reset } = useWizard();
  const { setSelectedCardId } = useDepositWizard();

  const onCardAdded = (cardId: string) => {
    setSelectedCardId(cardId);
    reset();
  };

  const handleSubmit = async (values: AddCardFormValues) => {
    const result = await walletService.addCard(values, undefined, onCardAdded);

    if (!result.ok) {
      toast({
        variant: "danger",
        title: "Failed to add card",
        description:
          result.error.message ||
          "Something went wrong adding your card. Please try again.",
      });
      return;
    }
  };

  return (
    <div className={styles.container}>
      <AddCardForm onSubmit={handleSubmit} />
    </div>
  );
};
